import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import _ from 'lodash'
import format from 'date-fns/format'
import addDays from 'date-fns/add_days';
import subDays from 'date-fns/sub_days';
import subMonths from 'date-fns/sub_months';
import subYears from 'date-fns/sub_years';
import differenceInDays  from 'date-fns/difference_in_calendar_days'
import { status } from 'grpc';
export default {
    namespaced: true,
    state: {
        learningJourneys: [],
        learningJourneysLoading: false,
        overview:{active:0,completed:0,upskilling:0,learning_time:0},
        overviewAll:{active:0,completed:0,upskilling:0,learning_time:0},
        pieChart:null,
        barChart:null,
        datatable:[],
        datatableAll:{past_year:[],past_6_months:[],past_3_months:[],all_time:[]},
        status:{filter:'',team:'',search:''},
        period:'past_6_months',
        dataTeem:[],
        datatableSearch:[],
        datatablefilter:[],
        loading:true
    },
    mutations: {
       
        setOverview(state: any, data: any) {
            state.overview = data
        },
        setOverviewAll(state: any, data: any) {
            state.overviewAll = data
        },
        setPieChart(state: any, data: any) {
            state.pieChart = data
        },
        setBarChart(state: any, data: any) {
            state.barChart = data
        },
        setDatatable(state: any, data: any) {
            state.datatable = data
        },
        setDatatableAll(state: any, data: any) {
            state.datatableAll = data
        },
        setPeriod(state: any, data: any) {
            state.period = data
        },
        setDataTeam(state: any, data: any) {
            state.dataTeam = data
        },
        setDatatableSearch(state: any, data: any) { 
            state.datatableSearch = data
        },
        setDatatableFilter(state: any, data: any) { 
            state.datatablefilter = data
        },
        setLoading(state: any, data: any) {
            state.loading = data
        },
    },
    actions: {
        async getLearningJourneys({ rootState,commit,dispatch,state }: any) {
            //console.log('getLearningJourneys')
            commit('setLoading',true)
            const datatableAll=_.cloneDeep(state.datatableAll)
            await dispatch('main/getOrganization',rootState.authen.user.company,{root:true})
            let dataAll:any = []
            let completed:any = []
            let datatable:any = []
            let overview:any = {active:0,completed:0,upskilling:0,learning_time:0}
            let progress = 0
            let completed_page=0
            const uniqueMember:any=[]
            const pieChart:any = {manager:0,self:0}
            const past6Month = format(subMonths(new Date(), 6), 'YYYY-MM-01')
            const newDate = format(new Date(), 'YYYY-MM-DD HH:mm:ss')
            const barChart:any = []
            const user_all=(await firebase.database().ref('users').orderByChild("company").equalTo(rootState.authen.user.company).once('value')).val()
            if(state.period=='all_time'&&state.datatableAll.all_time.length==0){
                //console.log('all_time')
                await firebase.firestore().collection('develop_skills').where('company', '==', rootState.authen.user.company).get().then(async(querySnapshot) => {
                    querySnapshot.docs.map(async (doc: any) => {
                        const data = doc.data(); 
                        data.id=doc.id
                        if(data.review_id){
                            data.initiated_by ='manager'
                            
                        }else {
                            data.initiated_by ='self'
                            
                        }
                        const emailKey=data.email.replace(/\./g, '||');
                        data.team_id=user_all&&user_all[emailKey]&&user_all[emailKey].team?user_all[emailKey].team:''
                        dataAll.push(data)
                        // bar chart
                        if(!barChart[format(data.createdate,'YYYY-MM')]){
                                barChart[format(data.createdate,'YYYY-MM')] = {
                                            self:0,
                                            manager:0
                                }
                        }
                        barChart[format(data.createdate,'YYYY-MM')][data.initiated_by]++
                         // pie chart
                        if(data.initiated_by=='self'){
                            pieChart.self++
                        }else{
                            pieChart.manager++
                        }
                        // overview
                        if(data.finish){
                            overview.completed++
                            progress=100
    
                        }else{
                            overview.active++
                            progress=isNaN(Math.round((data.read+1)*100/data.qty))?0:Math.round((data.read+1)*100/data.qty)
                        }
                        if(data.read||data.read==0){
                            overview.learning_time+=(data.read+1)
                        }
                        const find_member=_.find(uniqueMember,['email',data.email])
                        if(!find_member){
                            uniqueMember.push({email:data.email})
                        }
                        // datatable
                        const firstname=user_all&&user_all[emailKey]&&user_all[emailKey].firstname?user_all[emailKey].firstname:''
                        const lastname=user_all&&user_all[emailKey]&&user_all[emailKey].lastname?user_all[emailKey].lastname:''
                        datatable.push({
                            id:data.id,
                            name:data.set_name,
                            createdate:format(data.createdate,'YYYY-MM'),
                            initiated:data.initiated_by=='self'?'Self':'Manager',
                            progress:Number(progress),
                            members:firstname +' '+lastname,
                            date:data.createdate,
                            pic:user_all[emailKey]&&user_all[emailKey].profilepic?user_all[emailKey].profilepic:'',
                            status:data.finish?'completed':'progress',
                            team:user_all[emailKey]&&user_all[emailKey].team?user_all[emailKey].team:'',
                            completed_page:data.read?data.read+1:1,
                            email:data.email,
                            response:data.response,
                            members_name:firstname +' '+lastname.charAt(0),
                        })
                        
                        
                  
                    })
                    overview.upskilling=uniqueMember.length
                    datatableAll.all_time=datatable
                    console.log('datatableAll',datatableAll.all_time)
                    await commit('setDatatableAll',datatableAll)
                        if(state.status.team!==''){
                            dispatch('changeTeam',state.status.team)
                        }else if(state.status.search!==''){
                            commit('setPieChart',pieChart)
                            commit('setBarChart',barChart)
                            commit('setOverview',overview) 
                            dispatch('searchdatatable',state.status.search)
                        }
                        else {
                        commit('setPieChart',pieChart)
                        commit('setBarChart',barChart)
                        commit('setOverview',overview) 
                        commit('setDatatable',datatable)
                        // Apply In Progress filter by default after setting the data
                        dispatch('filterStatus', 'In Progress')
                        }
             
                })


            }else if(state.period=='past_year'&&state.datatableAll.past_year.length==0){
                //console.log('past_year')
                const pastYear = format(subYears(new Date(), 1), 'YYYY-01-01')
                const endYear = format(subYears(new Date(), 1), 'YYYY-12-31')
                //console.log('pastYear',pastYear)
                //console.log('endYear',endYear)
                await firebase.firestore().collection('develop_skills').where('company', '==', rootState.authen.user.company).where('createdate', '>=', pastYear).where('createdate', '<=', endYear).orderBy('createdate', 'desc').get().then(async(querySnapshot) => {
                    querySnapshot.docs.map(async (doc: any) => {
                        const data = doc.data(); 
                        data.id=doc.id
                        if(data.review_id){
                            data.initiated_by ='manager'
                            
                        }else {
                            data.initiated_by ='self'
                            
                        }
                        const emailKey=data.email.replace(/\./g, '||');
                        data.team_id=user_all&&user_all[emailKey]&&user_all[emailKey].team?user_all[emailKey].team:''
                        dataAll.push(data)
                        // bar chart
                        if(!barChart[format(data.createdate,'YYYY-MM')]){
                                barChart[format(data.createdate,'YYYY-MM')] = {
                                            self:0,
                                            manager:0
                                }
                        }
                        barChart[format(data.createdate,'YYYY-MM')][data.initiated_by]++
                         // pie chart
                        if(data.initiated_by=='self'){
                            pieChart.self++
                        }else{
                            pieChart.manager++
                        }
                        // overview
                        if(data.finish){
                            overview.completed++
                            progress=100
    
                        }else{
                            overview.active++
                            progress=isNaN(Math.round((data.read+1)*100/data.qty))?0:Math.round((data.read+1)*100/data.qty)
                        }
                        if(data.read||data.read==0){
                            overview.learning_time+=(data.read+1)
                        }
                        const find_member=_.find(uniqueMember,['email',data.email])
                        if(!find_member){
                            uniqueMember.push({email:data.email})
                        }
                        // datatable
                        const firstname=user_all&&user_all[emailKey]&&user_all[emailKey].firstname?user_all[emailKey].firstname:''
                        const lastname=user_all&&user_all[emailKey]&&user_all[emailKey].lastname?user_all[emailKey].lastname:''
                        datatable.push({
                            id:data.id,
                            name:data.set_name,
                            createdate:format(data.createdate,'YYYY-MM'),
                            initiated:data.initiated_by=='self'?'Self':'Manager',
                            progress:Number(progress),
                            members:firstname +' '+lastname,
                            date:data.createdate,
                            pic:user_all[emailKey]&&user_all[emailKey].profilepic?user_all[emailKey].profilepic:'',
                            status:data.finish?'completed':'progress',
                            team:user_all[emailKey]&&user_all[emailKey].team?user_all[emailKey].team:'',
                            completed_page:data.read?data.read+1:1,
                            email:data.email,
                            response:data.response,
                            members_name:firstname +' '+lastname.charAt(0),
                        })
                        
                        
                  
                    })
                    overview.upskilling=uniqueMember.length
                    if(datatableAll.past_year.length==0){
                        datatableAll.past_year=datatable
                    }
                    
                    commit('setDatatableAll',datatableAll)
                    if(state.status.team!==''){
                        dispatch('changeTeam',state.status.team)
                    }else if(state.status.search!==''){
                        commit('setPieChart',pieChart)
                        commit('setBarChart',barChart)
                        commit('setOverview',overview) 
                        dispatch('searchdatatable',state.status.search)
                    }else {
                        commit('setPieChart',pieChart)
                        commit('setBarChart',barChart)
                        commit('setOverview',overview) 
                        commit('setDatatable',datatable)
                        // Apply In Progress filter by default after setting the data
                        dispatch('filterStatus', 'In Progress')
                    }
          
             
                })

            }else{
                await firebase.firestore().collection('develop_skills').where('company', '==', rootState.authen.user.company).where('createdate', '>=', past6Month).orderBy('createdate', 'desc').get().then(async(querySnapshot) => {
                    querySnapshot.docs.map(async (doc: any) => {
                        const data = doc.data(); 
                        data.id=doc.id
                        if(data.review_id){
                            data.initiated_by ='manager'
                            
                        }else {
                            data.initiated_by ='self'
                            
                        }
                        const emailKey=data.email.replace(/\./g, '||');
                        data.team_id=user_all&&user_all[emailKey]&&user_all[emailKey].team?user_all[emailKey].team:''
                        dataAll.push(data)
                        // bar chart
                        if(!barChart[format(data.createdate,'YYYY-MM')]){
                                barChart[format(data.createdate,'YYYY-MM')] = {
                                            self:0,
                                            manager:0
                                }
                        }
                        barChart[format(data.createdate,'YYYY-MM')][data.initiated_by]++
                         // pie chart
                        if(data.initiated_by=='self'){
                            pieChart.self++
                        }else{
                            pieChart.manager++
                        }
                        // overview
                        if(data.finish){
                            overview.completed++
                            progress=100
    
                        }else{
                            overview.active++
                            progress=isNaN(Math.round((data.read+1)*100/data.qty))?0:Math.round((data.read+1)*100/data.qty)
                        }
                        if(data.read||data.read==0){
                            overview.learning_time+=(data.read+1)
                        }
                        const find_member=_.find(uniqueMember,['email',data.email])
                        if(!find_member){
                            uniqueMember.push({email:data.email})
                        }
                        // datatable
                        const firstname=user_all&&user_all[emailKey]&&user_all[emailKey].firstname?user_all[emailKey].firstname:''
                        const lastname=user_all&&user_all[emailKey]&&user_all[emailKey].lastname?user_all[emailKey].lastname:''
                        datatable.push({
                            id:data.id,
                            name:data.set_name,
                            createdate:format(data.createdate,'YYYY-MM'),
                            initiated:data.initiated_by=='self'?'Self':'Manager',
                            progress:Number(progress),
                            members:firstname +' '+lastname,
                            members_name:firstname +' '+lastname.charAt(0),
                            date:data.createdate,
                            pic:user_all[emailKey]&&user_all[emailKey].profilepic?user_all[emailKey].profilepic:'',
                            status:data.finish?'completed':'progress',
                            team:user_all[emailKey]&&user_all[emailKey].team?user_all[emailKey].team:'',
                            completed_page:data.read?data.read+1:1,
                            email:data.email,
                            response:data.response
                            
                        })
                        
                        
                  
                    })
                    overview.upskilling=uniqueMember.length
                    commit('setDatatableAll',{past_year:[],past_6_months:datatable,all_time:[]})
                    if(state.status.team!==''){
                        dispatch('changeTeam',state.status.team)
                    }else if(state.status.search!==''){
                        commit('setPieChart',pieChart)
                        commit('setBarChart',barChart)
                        commit('setOverview',overview) 
                        dispatch('searchdatatable',state.status.search)
                    }else {
                        commit('setOverviewAll',overview)
                        commit('setPieChart',pieChart)
                        commit('setBarChart',barChart)
                        commit('setOverview',overview) 
                        commit('setDatatable',datatable)
                        // Apply In Progress filter by default after setting the data
                        dispatch('filterStatus', 'In Progress')
                    }
                   
                   
          
             
                })
            }
            commit('setLoading',false)
            

        },
       
        async searchdatatable({commit,state,dispatch},searchText: string){
            //console.log('data',searchText)
            let datatable:any=[]
            state.status.search=searchText
            if(state.status.filter!==''){
                datatable=state.datatablefilter
            }else if(state.status.team!==''){
                datatable=state.dataTeam
            }else{
                datatable=state.datatableAll[state.period]
            }
            //console.log('datatable',datatable)
            var re = new RegExp(searchText, 'gi')
            if (!searchText) {
                // ถ้าไม่มีข้อความค้นหา ให้แสดงข้อมูลทั้งหมด
                state.status.search=''
                if(state.status.filter!==''){
                    dispatch('filterStatus',state.status.filter)
                }else{
                    commit('setDatatable', datatable);
                }
                
                return;
            }

            
        
            
            var filtered = _.filter(datatable, (item): any => {
                if (item.name.match(re)) {
                    return true
                } else if (item.members.match(re)) {
                    return true
                } else if (item.initiated.match(re)) {
                    return true
                }else if (item.createdate.match(re)) {
                    return true
                }
            });
            
            commit('setDatatableSearch', filtered);
            commit('setDatatable', filtered);

        
        },
        async filterStatus({commit,state,dispatch},status: string){
            let datatable:any=[]
            state.status.filter=status
            if(state.status.search!==''){
                datatable=state.datatableSearch
            }else if(state.status.team!==''){
                datatable=state.dataTeam
            }else{
                datatable=state.datatableAll[state.period]
            }

            if(status=='All'){
                state.status.filter=''
                commit('setDatatable', datatable);
            }else{
                state.status.filter=status
                let filtered = []
                
                if(status === 'Not Started') {
                    filtered = datatable.filter((item: any) => {
                        return item.status === 'progress' && item.progress === 0;
                    });
                } else if(status === 'In Progress') {
                    filtered = datatable.filter((item: any) => {
                        return item.status === 'progress' && item.progress > 0;
                    });
                } else if(status === 'Completed') {
                    filtered = datatable.filter((item: any) => {
                        return item.status === 'completed';
                    });
                }
                
                commit('setDatatableFilter', filtered);
                commit('setDatatable', filtered);
                if(state.status.search!==''){
                    dispatch('searchdatatable',state.status.search)
                }
            }
        },
        async changeTeam({commit,state,rootState,dispatch},team: string){
            //console.log('team',team)
            let datatable:any=[]
            if(state.period=='all_time'){
                datatable=state.datatableAll.all_time
            }else if(state.period=='past_year'){
                datatable=state.datatableAll.past_year
            }else if(state.period=='past_6_months'){
                datatable=state.datatableAll.past_6_months
            }else if(state.period=='past_3_months'){
                datatable=state.datatableAll.past_3_months
            }
            
            //const datatable=state.datatableAll
            //console.log('datatable',datatable)

            let overview:any = {active:0,completed:0,upskilling:0,learning_time:0}
            const pieChart:any = {manager:0,self:0}
            const barChart:any = {}
            const uniqueMember:any=[]
            const datatable_new:any=[]
            const organization=rootState.main.organization
            //console.log('organization',organization)
            if(team!=='all'){
                state.status.team=team
                if(organization[team]){
                    for(const item in organization[team]){
                        console.log('item',item)
                        const filtered = _.filter(datatable,(item_datatable) => {
                           
                            return item_datatable.team == item;
                        });
                        
                        if(filtered.length>0){
                            datatable_new.push(...filtered)
                            
                            for(const item_filtered of filtered){
                                overview.learning_time+=item_filtered.completed_page
                                if(item_filtered.status=='progress'){
                                    overview.active++
                                }else if(item_filtered.status=='completed'){
                                    overview.completed++
                                    const find_member=_.find(uniqueMember,['email',item_filtered.email])
                                    if(!find_member){
                                        uniqueMember.push({email:item_filtered.email})
                                    }
                                }
                                if(item_filtered.initiated=='Self'){
                                    pieChart.self++
                                    if(!barChart[item_filtered.createdate]){
                                        barChart[item_filtered.createdate] = {
                                            self:0,
                                            manager:0
                                        }
                                    }
                                    barChart[item_filtered.createdate].self++
                                }else{
                                    pieChart.manager++
                                    if(!barChart[item_filtered.createdate]){
                                        barChart[item_filtered.createdate] = {
                                            self:0,
                                            manager:0
                                        }
                                    }
                                    barChart[item_filtered.createdate].manager++
                                }
                            }
                        }
                    }
                    
                }else{
                    const filtered = _.filter(datatable,(item_datatable) => {
                       
                        return item_datatable.team == team;
                    });
                    if(filtered.length>0){
                        datatable_new.push(...filtered)
                        for(const item_filtered of filtered){
                            overview.learning_time+=item_filtered.completed_page
                            if(item_filtered.status=='progress'){
                                overview.active++
                            }else if(item_filtered.status=='completed'){
                                overview.completed++
                                const find_member=_.find(uniqueMember,['email',item_filtered.email])
                                if(!find_member){
                                    uniqueMember.push({email:item_filtered.email})
                                }
                            }
                            if(item_filtered.initiated=='Self'){
                                pieChart.self++
                                if(!barChart[item_filtered.createdate]){
                                    barChart[item_filtered.createdate] = {
                                        self:0,
                                        manager:0
                                    }
                                }
                                barChart[item_filtered.createdate].self++
                            }else{
                                pieChart.manager++
                                if(!barChart[item_filtered.createdate]){
                                    barChart[item_filtered.createdate] = {
                                        self:0,
                                        manager:0
                                    }
                                }
                                barChart[item_filtered.createdate].manager++
                            }
                        }
                    }
                }
                overview.upskilling=uniqueMember.length
                commit('setDataTeam',datatable_new)
                if(state.status.search!==''){
                    dispatch('searchdatatable',state.status.search)
                }else if(state.status.filter!==''){
                    dispatch('filterStatus',state.status.filter)
                }else{
                    commit('setDatatable', datatable_new);
                    // console.log('datatable_new',datatable_new)
                }
    
                commit('setOverview',overview)
                commit('setPieChart',pieChart)
                commit('setBarChart',barChart)
                
                

            }else{
                state.status.team=''
                const datatable_new:any=[]
                    for(const item of datatable){
                     
                        
                            datatable_new.push(item)
                                overview.learning_time+=item.completed_page
                                    if(item.status=='progress'){
                                        overview.active++
                                    }else if(item.status=='completed'){
                                        overview.completed++
                                        const find_member=_.find(uniqueMember,['email',item.email])
                                        if(!find_member){
                                            uniqueMember.push({email:item.email})
                                        }
                                    }
                                    if(item.initiated=='Self'){
                                        pieChart.self++
                                        if(!barChart[item.createdate]){
                                            barChart[item.createdate] = {
                                                self:0,
                                                manager:0
                                            }
                                        }
                                        barChart[item.createdate].self++
                                    }else{
                                        pieChart.manager++
                                        if(!barChart[item.createdate]){
                                            barChart[item.createdate] = {
                                                self:0,
                                                manager:0
                                            }
                                        }
                                        barChart[item.createdate].manager++
                                    }

                        
                    }
                   
                        commit('setDatatable', datatable_new);
                        commit('setOverview',overview)
                        commit('setPieChart',pieChart)
                        commit('setBarChart',barChart)   
            }
        },
        async filterPeriod({commit,state,dispatch},period: string){
            // console.log('period',period)
            
            let overview:any = {active:0,completed:0,upskilling:0,learning_time:0}
            const pieChart:any = {manager:0,self:0}
            const barChart:any = {}
            const uniqueMember:any=[]
            if(period=='All-time'){
                
                commit('setPeriod','all_time')
                if(state.datatableAll.all_time.length==0){
                    
                    await dispatch('getLearningJourneys','all_time')
                }else{
                    const datatable=state.datatableAll.all_time
                    const datatable_new:any=[]
                    for(const item of datatable){
                        //console.log('item',format(subMonths(new Date(), 2), 'YYYY-MM-01'))
                        
                            datatable_new.push(item)
                                overview.learning_time+=item.completed_page
                                    if(item.status=='progress'){
                                        overview.active++
                                    }else if(item.status=='completed'){
                                        overview.completed++
                                        const find_member=_.find(uniqueMember,['email',item.email])
                                        if(!find_member){
                                            uniqueMember.push({email:item.email})
                                        }
                                    }
                                    if(item.initiated=='Self'){
                                        pieChart.self++
                                        if(!barChart[item.createdate]){
                                            barChart[item.createdate] = {
                                                self:0,
                                                manager:0
                                            }
                                        }
                                        barChart[item.createdate].self++
                                    }else{
                                        pieChart.manager++
                                        if(!barChart[item.createdate]){
                                            barChart[item.createdate] = {
                                                self:0,
                                                manager:0
                                            }
                                        }
                                        barChart[item.createdate].manager++
                                    }

                        
                    }
                    if(state.status.team!==''){
                        dispatch('changeTeam',state.status.team)
                    }else if(state.status.search!==''){
                        commit('setPieChart',pieChart)
                        commit('setBarChart',barChart)
                        commit('setOverview',overview) 
                        dispatch('searchdatatable',state.status.search)
                    }else {
                        commit('setDatatable', datatable_new);
                        commit('setOverview',overview)
                        commit('setPieChart',pieChart)
                        commit('setBarChart',barChart)

                    }
                    
                }
                
            }else if(period=='Past 6-months'){
                commit('setPeriod','past_6_months')
                const datatable=state.datatableAll.past_6_months
                const datatable_new:any=[]
                for(const item of datatable){
                    //console.log('item',format(subMonths(new Date(), 2), 'YYYY-MM-01'))
                    
                        datatable_new.push(item)
                            overview.learning_time+=item.completed_page
                                if(item.status=='progress'){
                                    overview.active++
                                }else if(item.status=='completed'){
                                    overview.completed++
                                    const find_member=_.find(uniqueMember,['email',item.email])
                                    if(!find_member){
                                        uniqueMember.push({email:item.email})
                                    }
                                }
                                if(item.initiated=='Self'){
                                    pieChart.self++
                                    if(!barChart[item.createdate]){
                                        barChart[item.createdate] = {
                                            self:0,
                                            manager:0
                                        }
                                    }
                                    barChart[item.createdate].self++
                                }else{
                                    pieChart.manager++
                                    if(!barChart[item.createdate]){
                                        barChart[item.createdate] = {
                                            self:0,
                                            manager:0
                                        }
                                    }
                                    barChart[item.createdate].manager++
                                }

                    
                }
                if(state.status.team!==''){
                    dispatch('changeTeam',state.status.team)
                }else if(state.status.search!==''){
                    commit('setPieChart',pieChart)
                    commit('setBarChart',barChart)
                    commit('setOverview',overview) 
                    dispatch('searchdatatable',state.status.search)
                }else {
                    commit('setDatatable', datatable_new);
                    commit('setOverview',overview)
                    commit('setPieChart',pieChart)
                    commit('setBarChart',barChart)

                }

            }else if(period=='Past 3-months'){
                let datatableAll=state.datatableAll
                const datatable=state.datatableAll.past_6_months
                const datatable_new:any=[]
                for(const item of datatable){
                    //console.log('item',format(subMonths(new Date(), 2), 'YYYY-MM-01'))
                    if(item.date>=format(subMonths(new Date(), 2), 'YYYY-MM-01')){
                        datatable_new.push(item)
                            overview.learning_time+=item.completed_page
                                if(item.status=='progress'){
                                    overview.active++
                                }else if(item.status=='completed'){
                                    overview.completed++
                                    const find_member=_.find(uniqueMember,['email',item.email])
                                    if(!find_member){
                                        uniqueMember.push({email:item.email})
                                    }
                                }
                                if(item.initiated=='Self'){
                                    pieChart.self++
                                    if(!barChart[item.createdate]){
                                        barChart[item.createdate] = {
                                            self:0,
                                            manager:0
                                        }
                                    }
                                    barChart[item.createdate].self++
                                }else{
                                    pieChart.manager++
                                    if(!barChart[item.createdate]){
                                        barChart[item.createdate] = {
                                            self:0,
                                            manager:0
                                        }
                                    }
                                    barChart[item.createdate].manager++
                                }

                    }
                }
                datatableAll.past_3_months=datatable_new
                    commit('setDatatableAll',datatableAll)
                if(state.status.team!==''){
                    dispatch('changeTeam',state.status.team)
                }else if(state.status.search!==''){
                    commit('setPieChart',pieChart)
                    commit('setBarChart',barChart)
                    commit('setOverview',overview) 
                    dispatch('searchdatatable',state.status.search)
                }else {
                    commit('setDatatable', datatable_new);
                    commit('setOverview',overview)
                    commit('setPieChart',pieChart)
                    commit('setBarChart',barChart)

                }
                

            }else if(period=='Past year'){
                commit('setPeriod','past_year')
                if(state.datatableAll.past_year.length==0){
                    await dispatch('getLearningJourneys','past_year')
                }else{
                    const datatable=state.datatableAll.past_year
                    const datatable_new:any=[]
                    for(const item of datatable){
                        //console.log('item',format(subMonths(new Date(), 2), 'YYYY-MM-01'))
                        
                            datatable_new.push(item)
                                overview.learning_time+=item.completed_page
                                    if(item.status=='progress'){
                                        overview.active++
                                    }else if(item.status=='completed'){
                                        overview.completed++
                                        const find_member=_.find(uniqueMember,['email',item.email])
                                        if(!find_member){
                                            uniqueMember.push({email:item.email})
                                        }
                                    }
                                    if(item.initiated=='Self'){
                                        pieChart.self++
                                        if(!barChart[item.createdate]){
                                            barChart[item.createdate] = {
                                                self:0,
                                                manager:0
                                            }
                                        }
                                        barChart[item.createdate].self++
                                    }else{
                                        pieChart.manager++
                                        if(!barChart[item.createdate]){
                                            barChart[item.createdate] = {
                                                self:0,
                                                manager:0
                                            }
                                        }
                                        barChart[item.createdate].manager++
                                    }

                        
                    }
                    if(state.status.team!==''){
                        dispatch('changeTeam',state.status.team)
                    }else if(state.status.search!==''){
                        commit('setPieChart',pieChart)
                        commit('setBarChart',barChart)
                        commit('setOverview',overview) 
                        dispatch('searchdatatable',state.status.search)
                    }else {
                        commit('setDatatable', datatable_new);
                        commit('setOverview',overview)
                        commit('setPieChart',pieChart)
                        commit('setBarChart',barChart)
                    }
                }
                
            }
            
            
        },
        
    },
    getters: {
        learningJourneys: (state: any) => state.learningJourneys,
        overview: (state: any) => state.overview,
        pieChart: (state: any) => state.pieChart,
        barChart: (state: any) => state.barChart,
        datatable: (state: any) => state.datatable,
        loading: (state: any) => state.loading,
        topLearners: (state: any) => {
            // Get data based only on team and time period filters
            let data: any[] = [];
            if (state.status.team !== '' && state.dataTeam) {
                // If team is selected, use team data
                data = state.dataTeam;
            } else if (state.datatableAll[state.period]) {
                // Otherwise use all data for the selected time period
                data = state.datatableAll[state.period];
            }
            
            // Count journeys per user
            const counts: Record<string, {email: string, name: string, pic: string, count: number}> = {};
            data.forEach((journey: any) => {
                const email = journey.email;
                if (!counts[email]) {
                    counts[email] = {
                        email: email,
                        name: journey.members,
                        pic: journey.pic,
                        count: 0
                    };
                }
                counts[email].count++;
            });
            
            // Convert to array and sort by count descending
            const result = Object.values(counts)
                .sort((a: {count: number}, b: {count: number}) => b.count - a.count);
                
            return result;
        },
        topSixLearners: (state: any, getters: any) => {
            // Return only the top 6 learners for the compact view
            return getters.topLearners.slice(0, 6);
        }
    }
}
